import { RecoveryPaymentTab } from '@secca/shared/models/recoveryPaymentTab';
import { Recovery } from '@secca/shared/models/recovery';
import { RecoveryPaymentStatus } from '@secca/shared/models/enums';

export class RecoveryPaymentUtils {
  static isPaymentsApprovedOrFinalized(payments: RecoveryPaymentTab, recovery: Recovery): boolean {
    const recoveryPayments = payments.caseRecoveryPayments.filter(payment =>
      String(payment.recoveryId) === String(recovery.id)
    );
    return recoveryPayments.length > 0 &&
      recoveryPayments.every(payment =>
        [RecoveryPaymentStatus.APPROVED, RecoveryPaymentStatus.FINALIZED].includes(payment.getStatus())
      );
  }
}

